'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styles = require('./styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NEXT_TICK = 16;

var NitroRipple = function (_Component) {
  _inherits(NitroRipple, _Component);

  function NitroRipple(props) {
    _classCallCheck(this, NitroRipple);

    var _this = _possibleConstructorReturn(this, (NitroRipple.__proto__ || Object.getPrototypeOf(NitroRipple)).call(this, props));

    _this.trigger = function () {
      _this.clear();
      _this.stop();
      _this.playingTimer = setTimeout(_this.play, NEXT_TICK);
    };

    _this.clear = function () {
      if (_this.playingTimer) {
        clearTimeout(_this.playingTimer);
      }
    };

    _this.play = function () {
      _this.setState({
        playing: true
      });

      _this.playingTimer = setTimeout(_this.stop, _this.props.animationDuration);
    };

    _this.stop = function () {
      _this.setState({
        playing: false
      });
    };

    _this.state = {
      playing: props.playOnMount
    };
    return _this;
  }

  _createClass(NitroRipple, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.variant !== nextProps.variant) {
        this.trigger();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.clear();
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_styles.Ripple, _extends({
        playing: this.state.playing
      }, this.props));
    }
  }]);

  return NitroRipple;
}(_react.Component);

NitroRipple.propTypes = {
  animationDuration: _propTypes2.default.number,
  animationDelay: _propTypes2.default.number,
  animationIterationCount: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  playOnMount: _propTypes2.default.bool,
  scaleInitial: _propTypes2.default.number,
  scaleFinal: _propTypes2.default.number,
  variant: _propTypes2.default.string
};

NitroRipple.defaultProps = {
  animationDuration: 600,
  animationDelay: 0,
  animationIterationCount: 1,
  playOnMount: false,
  scaleInitial: 1.5,
  scaleFinal: 3.5,
  variant: 'primary'
};

exports.default = NitroRipple;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-ripple/NitroRipple.js
// module id = 3031
// module chunks = 4